import { render, staticRenderFns } from "./editcommand.vue?vue&type=template&id=c5a4784a&"
import script from "./editcommand.vue?vue&type=script&lang=ts&"
export * from "./editcommand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editcommand.vue"
export default component.exports